import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=5848bfb4&scoped=true"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=5848bfb4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848bfb4",
  null
  
)

export default component.exports